export const MIME_TYPES: {[key: string]: string} = {
  image: 'image/jpg, image/jpeg, image/png, image/tiff, image/bmp, image/svg+xml',
  document: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf',
  excel: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv'
};
